import {Component, OnInit} from '@angular/core';
import {SystemUserService} from '../../../services/system-user.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  standalone: false,
    selector: 'app-system-user-edit',
    templateUrl: './system-user-edit.component.html',
})
export class SystemUserEditComponent implements OnInit {
    systemUserId = '';
    systemUser: any = {
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          confirm_password: '',
          mobile_number: '',
          id_role: 1,
          status: 1
      };
  
      validationTriggered = false;
  
      constructor(
          private systemUserService: SystemUserService,
          private activatedRoute: ActivatedRoute,
          private spinner : NgxSpinnerService,
          private toaster : ToastrService,
          private router: Router,
      ) {}
  
      ngOnInit(): any {
        this.activatedRoute.paramMap.subscribe((params: any) => {
          this.systemUserId = params.params.id;
          this.getSystemUserDetail();
        });
      }
  
      getSystemUserDetail(): void {
          this.spinner.show();
          this.systemUserService.getSystemUser(this.systemUserId).subscribe((result: any) => {
              this.spinner.hide();
              this.systemUser = {
                  first_name: result.first_name,
                  last_name: result.last_name,
                  email: result.email,
                  mobile_number: result.mobile_number,
                  id_role: result.id_role,
                  status: result.status,
              };
          },
          (error: any) => {
              console.log(error);
          });
      }
  
      editSystemUser() {
          this.validationTriggered = true;
  
          if (!this.isSystemUserFilled(this.systemUser)) {
              return;
          }
  
          const { confirm_password, ...userData } = this.systemUser;
          this.spinner.show();
          this.systemUserService.updateSystemUser(this.systemUserId, userData).subscribe((result: any) => {
              this.spinner.hide();
              this.validationTriggered = false;
              this.toaster.success('System User Updated Successfully.');
              this.router.navigate(['/system-user/list']);
          },
          (error: any) => {
              console.log(error);
          });
      }
  
      isSystemUserFilled(systemUser: any): boolean {
          for (const su in systemUser) {
              if (su != 'id_role') {
                  if (systemUser[su] == '') {
                      return false;
                  }
              } 
          }
          if (systemUser.password !== systemUser.confirm_password) return false;
          return true;
      }
  
      isValidEmail(email: string): boolean {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailPattern.test(email);
      }
  }